/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelUpPrestigeTransaction
 */
export interface FuelUpPrestigeTransaction {
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeTransaction
     */
    fromLevel: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpPrestigeTransaction
     */
    toLevel: number;
    /**
     * Amount of fuel sacrificed for prestige
     * @type {number}
     * @memberof FuelUpPrestigeTransaction
     */
    fuelSacrificed: number;
    /**
     * List of bonus IDs unlocked
     * @type {Array<string>}
     * @memberof FuelUpPrestigeTransaction
     */
    bonusesGained?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof FuelUpPrestigeTransaction
     */
    timestamp: Date;
    /**
     * 
     * @type {string}
     * @memberof FuelUpPrestigeTransaction
     */
    note?: string;
}

/**
 * Check if a given object implements the FuelUpPrestigeTransaction interface.
 */
export function instanceOfFuelUpPrestigeTransaction(value: object): value is FuelUpPrestigeTransaction {
    if (!('fromLevel' in value) || value['fromLevel'] === undefined) return false;
    if (!('toLevel' in value) || value['toLevel'] === undefined) return false;
    if (!('fuelSacrificed' in value) || value['fuelSacrificed'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function FuelUpPrestigeTransactionFromJSON(json: any): FuelUpPrestigeTransaction {
    return FuelUpPrestigeTransactionFromJSONTyped(json, false);
}

export function FuelUpPrestigeTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpPrestigeTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'fromLevel': json['fromLevel'],
        'toLevel': json['toLevel'],
        'fuelSacrificed': json['fuelSacrificed'],
        'bonusesGained': json['bonusesGained'] == null ? undefined : json['bonusesGained'],
        'timestamp': (new Date(json['timestamp'])),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function FuelUpPrestigeTransactionToJSON(json: any): FuelUpPrestigeTransaction {
    return FuelUpPrestigeTransactionToJSONTyped(json, false);
}

export function FuelUpPrestigeTransactionToJSONTyped(value?: FuelUpPrestigeTransaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fromLevel': value['fromLevel'],
        'toLevel': value['toLevel'],
        'fuelSacrificed': value['fuelSacrificed'],
        'bonusesGained': value['bonusesGained'],
        'timestamp': ((value['timestamp']).toISOString()),
        'note': value['note'],
    };
}

